// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2yR2B","icon":"index_icon_3Ul4u"};